import { ApiResponse, PaginatedCollection, directusApi } from '@/api';
import { validateFileName } from '@/utils';
import lodash from 'lodash';

export interface Location {
    id?: number;
    name: string;
    schedule: string;
    phone: string;
    whatsapp: string;
    address: string;
    url: string;
    geolocation: any;
}

export interface LocationState {
    activeLocation: Location | null;
    activeLocationLoading: boolean;

    allLocations: Array<Location>;
    allLocationsLoading: boolean;
    locationsPerPage: number;
    locationsPage: number;
    locationsTotal: number;
}

const state: LocationState = {
    activeLocation: {
        id: 0,
        name: '',
        schedule: '',
        phone: '',
        whatsapp: '',
        address: '',
        url: '',
        geolocation: []
    },
    activeLocationLoading: false,

    allLocations: [],
    allLocationsLoading: false,
    locationsPerPage: 1,
    locationsPage: 1,
    locationsTotal: 1,
};

const defaultLocation = {
    id: 0,
    name: '',
    schedule: '',
    phone: '',
    whatsapp: '',
    address: '',
    url: '',
    geolocation: []
}

const mutations = {
    TOGGLE_ALLLOCATIONS_LOADING(state: LocationState, data: boolean) {
        state.allLocationsLoading = data;
    },
    SET_ALLLOCATIONS(state: LocationState, data: PaginatedCollection) {
        state.allLocations = data.items;
        state.locationsPerPage = data.perPage;
        state.locationsPage = data.currentPage;
        state.locationsTotal = data.totalItems;
    },
    TOGGLE_ACTIVE_LOCATION_LOADING(state: LocationState, data: boolean) {
        state.activeLocationLoading = data;
    },
    REMOVE_LOCATION(state: LocationState, id: number) {
        state.allLocations = lodash.remove(state.allLocations, function (n) {
            return n.id != id;
        });
    },
    SET_ACTIVE_LOCATION(state: LocationState, data: Location) {
        // let image = data.image ? { id: data.image, url: `https://directus.prodelec.app/assets/${data.image}`, origin: 'directus' } : null;
        state.activeLocation = data;
    },
};

const actions = {
    async getAll(
        { _, commit }: any,
        {
            search,
            page,
        }: any | null
    ) {
        commit('TOGGLE_ALLLOCATIONS_LOADING', true);

        let limit = 20;
        let params = '';
        if (search) {
            params += `&search=${search}`;
        }
        params += `&meta=total_count&meta=filter_count`;
        if (page) params += `&limit=20&offset=${(page - 1) * limit}`;

        let endpoint = `items/store_locations?${params}`;

        await directusApi('GET', endpoint)
            .then(res => {
                commit('SET_ALLLOCATIONS', {
                    items: res.data.data,
                    perPage: limit,
                    currentPage: page,
                    totalItems: res.data.meta.filter_count,
                });
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ALLLOCATIONS_LOADING', false);
            });
    },
    async getOne({ _, commit }: any, id: any | null = null) {
        commit('TOGGLE_ACTIVE_LOCATION_LOADING', true);
        if (id) {
            await directusApi('GET', `items/store_locations/${id}`)
                .then(res => {
                    // console.log(res.data.data);
                    commit('SET_ACTIVE_LOCATION', res.data.data);
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    commit('TOGGLE_ACTIVE_LOCATION_LOADING', false);
                });
        } else {
            commit('SET_ACTIVE_LOCATION', defaultLocation);
            commit('TOGGLE_ACTIVE_LOCATION_LOADING', false);
        }
    },
    async toggleLocationFalse({ _, commit }: any) {
        commit('TOGGLE_ACTIVE_LOCATION_LOADING', false);
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
